<div
    x-data="feedbackComponent(message)"
    class="chat-feedback-container"
    @feedback-reset.window="hideFeedback"
    x-ref="feedbackScrollContainer"
>
    <template x-if="!isHidden">
        <div class="chat-widget-message chat-widget-message-type-bot-answer chat-widget-message-feedback-content">
            <div class="feedback-buttons" :class="{ 'disabled': isRatingLocked }">
                <button
                    type="button"
                    class="feedback-btn feedback-btn-up"
                    :class="buttonUpCssClass"
                    :disabled="isRatingLocked"
                    @click="handleThumbUp()"
                    aria-label="Antwort hilfreich"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="20px" class="feedback-buttons-up" viewBox="0 0 48 48">
                        <path class="thumb-up-filled" d="M28.93 5.08a4.14 4.14 0 0 1 3.24 4.85l-.2.98a21 21 0 0 1-2.47 6.48h12.38a4.13 4.13 0 0 1 1.9 7.78 4.12 4.12 0 0 1-1.81 7.26 4.14 4.14 0 0 1-2.25 6.05q.1.45.1.9a4.1 4.1 0 0 1-4.13 4.12H27.3a8.3 8.3 0 0 1-4.58-1.38l-3.3-2.2a8.3 8.3 0 0 1-3.67-6.87V23.5a8.3 8.3 0 0 1 3.1-6.45l.63-.5a12.4 12.4 0 0 0 4.4-7.24l.2-.98a4.1 4.1 0 0 1 4.85-3.25M4.75 18.76h5.5A2.75 2.75 0 0 1 13 21.51v19.25a2.75 2.75 0 0 1-2.75 2.75h-5.5A2.75 2.75 0 0 1 2 40.76V21.51a2.75 2.75 0 0 1 2.75-2.75"/>
                    </svg>
                </button>

                <button
                    type="button"
                    class="feedback-btn feedback-btn-down"
                    :class="buttonDownCssClass"
                    :disabled="isRatingLocked"
                    @click="handleThumbDown()"
                    aria-label="Antwort nicht hilfreich"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="20px" class="feedback-buttons-down" viewBox="0 0 48 48">
                        <path class="thumb-up-filled" d="M29.24 45.06a4.13 4.13 0 0 1-4.88-3.21l-.2-.97c-.6-2.85-2.18-5.4-4.46-7.2l-.64-.5a8.3 8.3 0 0 1-3.16-6.42l-.08-9.55a8.3 8.3 0 0 1 3.61-6.9l3.28-2.23a8.4 8.4 0 0 1 4.56-1.42l8.39-.07a4.14 4.14 0 0 1 4.08 4.99q.44.14.84.37a4.13 4.13 0 0 1 1.46 5.65 4.1 4.1 0 0 1 1.86 7.24 4.12 4.12 0 0 1-1.83 7.8l-12.38.1c1.19 2 2.05 4.18 2.53 6.46l.2.97a4.1 4.1 0 0 1-3.2 4.87M4.94 31.58a2.76 2.76 0 0 1-2.78-2.72L2 9.61a2.76 2.76 0 0 1 2.72-2.78l5.5-.05A2.76 2.76 0 0 1 13 9.5l.16 19.25a2.76 2.76 0 0 1-2.72 2.78z"/>
                    </svg>
                </button>
                <span class="chat-widget-message-feedback-confirmation"
                     x-show="feedbackState !== 'none'"
                     x-text="confirmationText">
                </span>
            </div>
            <template x-if="showReasonPanel">
                <div>
                    <div
                        x-show="showReasonPanel"
                        class="feedback-reason-panel"
                        role="group"
                        aria-labelledby="reason-title"
                    >
                        <div class="feedback-reason-panel-content">
                            <p id="reason-title" class="feedback-reason-title">Was trifft hierbei am meisten zu?</p>

                            <div class="feedback-reason-options">
                                <template x-for="option in reasonOptions" :key="option.code">
                                    <label class="feedback-reason-option">
                                        <input
                                            type="radio"
                                            name="feedbackReason"
                                            :value="option.code"
                                            x-model="selectedReasonCode"
                                            @change="onReasonChange()"
                                            :disabled="feedbackState !== 'thumbDown' "
                                        />
                                        <span x-text="option.label"></span>
                                    </label>
                                </template>

                                <template x-if="selectedReasonCode === 'other'">
                                    <div x-show="selectedReasonCode === 'other'" class="feedback-freetext">
                                        <p id="reason-other-title" class="feedback-reason-title" x-text="freeTextTitle"></p>
                                        <textarea
                                            x-model="freeText"
                                            maxlength="350"
                                            :placeholder="freeTextPlaceholder"
                                            class="feedback-freetext__textarea"
                                            @input="updateCharCount"
                                        ></textarea>
                                        <span class="feedback-freetext__counter" x-text="freeTextCharCount + '/' + maxFeedbackFreeTextLength"></span>
                                    </div>
                                </template>
                                <button
                                    type="button"
                                    class="feedback-submit chat-widget-button"
                                    :disabled="!isSubmitEnabled"
                                    @click="submitFeedbackReason"
                                >
                                    <span>Feedback absenden</span>
                                </button>
                                <span x-show="showReasonPanel && feedbackState === 'completed'"
                                      class="feedback-submit-confirmation"
                                      :class="{ 'disabled': feedbackState === 'completed' }"
                                      x-text="feedbackSubmitConfirmationText">
                                    </span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </template>
</div>
